import { Directive, ElementRef, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';

@Directive({
	// eslint-disable-next-line @angular-eslint/directive-selector
	selector: '[progressiveTyping]',
	standalone: true
})
export class ProgressiveTypingDirective implements OnChanges, OnDestroy {
	@Input() text: string = '';
	@Input() typingSpeed: number = 20;

	private typedContent: string = '';
	private typingInterval: any;

	constructor(private elementRef: ElementRef) { }

	ngOnChanges(changes: SimpleChanges) {
		if (changes['text']) {
			this.processTextUpdate();
		}
	}

	private processTextUpdate() {
		clearInterval(this.typingInterval);

		const newContent = String(this.text);
		const commonPrefixLength = this.findCommonPrefixLength(this.typedContent, newContent);
		const contentToType = newContent.slice(commonPrefixLength);

		this.typedContent = newContent.slice(0, commonPrefixLength);
		this.updateDisplayedContent();

		this.typeContentProgressively(contentToType);
	}

	private findCommonPrefixLength(existingText: string, newText: string): number {
		let commonLength = 0;
		while (commonLength < existingText.length &&
			commonLength < newText.length &&
			existingText[commonLength] === newText[commonLength]) {
			commonLength++;
		}
		return commonLength;
	}

	private updateDisplayedContent() {
		this.elementRef.nativeElement.innerHTML = this.typedContent;
	}

	private typeContentProgressively(contentToType: string) {
		const wordsToType = contentToType.split(/(?<=\s+)/);
		let wordIndex = 0;

		this.typingInterval = setInterval(() => {
			if (wordIndex < wordsToType.length) {
				this.typedContent += wordsToType[wordIndex];
				this.updateDisplayedContent();
				wordIndex++;
			} else {
				clearInterval(this.typingInterval);
			}
		}, this.typingSpeed);
	}

	ngOnDestroy() {
		clearInterval(this.typingInterval);
	}
}
